import { Role } from 'shared/@types';
import trustpilotReviews from 'shared/@generated/trustpilot-reviews.json';
import { staticImage } from 'shared/library/static-images';
import type { MediaImageSource } from 'shared/library/media-image-versions';

export interface Review {
  name: string;
  rating: number;
  date?: string;
  body: string;
  image: string | MediaImageSource | null;
  role: Role;
  identifier: string;
}

const buyerReviews = trustpilotReviews.filter((r) => r.role === 'buyer') as Review[];

const breederReviews: Review[] = [
  {
    name: 'Mathilda Olsson',
    rating: 5,
    body: `Get a Pet är en pålitlig plattform som underlättar för mig som uppfödare att nå seriösa valpköpare på ett enkelt och tryggt sätt. Som uppfödare uppskattar jag att Get a Pet är lätt att använda och skapar en trygg kontakt mellan uppfödare och valpköpare.`,
    image: staticImage('review-royal-inferno'),
    role: 'seller',
    identifier: 'royal-inferno',
  },
  {
    name: 'Susann Olhage',
    rating: 5,
    body: `Som uppfödare känns det alltid viktigt att våra valpar får rätt hem. Via Get a Pet har jag mött många engagerade valpköpare som verkligen tagit sig tid att lära känna rasen innan de bestämmer sig. Det ger en trygghet både för oss och för hundarna.
 
Jag uppskattar att tjänsten är enkel att använda och att kommunikationen med valpköparna blir så smidig. För mig är det värdefullt att kunna visa upp både mina hundar och mitt arbete på en plattform som tar uppfödning på allvar och hjälper oss uppfödare att nå ut på ett seriöst sätt.
 
Det är en härlig känsla när man får följa en familj som hittar ”sin” hund via Get a Pet – då vet man att plattformen verkligen gör skillnad.`,
    image: staticImage('review-black-oranges'),
    role: 'seller',
    identifier: 'black-oranges-pomeranian',
  },
  {
    name: 'Anki Nordberg',
    rating: 5,
    body: `Jag annonserar på Get a Pet eftersom jag känner mig trygg med mina annonser här. Jag uppskattar funktionen PetPay och att Get a Pet har en enkät som valpköpare kan fylla i innan man tar direkt kontakt.`,
    image: staticImage('review-lugnets'),
    role: 'seller',
    identifier: 'lugnets',
  },
  {
    name: 'Fredrica Östberg',
    rating: 5,
    body: `Get a Pet är en trygg och seriös sida som ger både uppfödare och valpköpare förtroende. Allt vi behöver finns samlat och det är enkelt att göra rätt. Vi på Fredsduvan's Kennel tackar för alla intresserade och valpköpare som hittat oss här – vi har inte behövt annonsera någon annanstans och har redan flera som väntar på nästa kull.`,
    image: staticImage('review-fredduvans'),
    role: 'seller',
    identifier: 'fredsduvans-kennel',
  },
  {
    name: 'Maria Grönlund',
    rating: 5,
    body: `Get a Pet erbjuder en väldigt informativ och användarvänlig plattform för blivande hundägare. Man får ta del av presentationer av olika hundraser, vilket gör det enkelt att jämföra egenskaper, behov och temperament för varje ras. Det här hjälper verkligen till att hitta en ras som passar ens livsstil.
 
En bra funktion är trygga valpköp – genom att ge råd om seriösa uppfödare skapar de en tryggare väg för alla som vill skaffa valp. Get a Pet är en utmärkt resurs för den som vill ta ett ansvarsfullt och informerat beslut inför sitt val av hund.`,
    image: staticImage('review-chillipax'),
    role: 'seller',
    identifier: 'chillipax',
  },
  {
    name: 'Cecilia Florén',
    rating: 5,
    body: `När jag själv skulle skaffa en Bichon Frisé sökte jag mycket på Skaffa Hund. Den hjälpte mig som blivande valpköpare att hitta rätt och att kunna läsa på om rasen. Det var en djungel att hitta uppfödare och just den uppfödare som var rätt för mig och mitt köp.
 
Idag, snart fyra år senare, står jag själv som utbildad uppfödare av Bichon Frisé och ska få min första kull i november 2025. För mig skulle det vara ovärderligt om blivande valpköpare, precis som jag, kunde finna mig som nybliven uppfödare. De flesta går på tidigare uppfödares recensioner.`,
    image: staticImage('review-cecilias-stars'),
    role: 'seller',
    identifier: 'cecillas-star',
  },
];

export { breederReviews, buyerReviews };
